import { Text } from '@react-pdf/renderer';

import styles from './Styles';

export const FreeText = () => (
  <Text style={{ ...styles.text, position: 'absolute', bottom: 0 }}>
    This is a computer-generated document. No signature is required.
  </Text>
);
